import React from 'react';
import { ContentSection } from '../ui/ContentSection';
import { Target } from 'lucide-react';
import { motion } from 'framer-motion';
export function Benefits() {
  return <ContentSection background="white" data-id="element-1">
      <div className="grid md:grid-cols-2 gap-12 items-center mb-16" data-id="element-2">
        <div data-id="element-3">
          <span className="text-amber-600 font-bold tracking-wider text-sm uppercase mb-4 block" data-id="element-4">
            BENEFICIOS CLAROS
          </span>
          <h2 className="text-3xl md:text-5xl font-bold text-[#1A1A1A] mb-6" data-id="element-5">
            Qué vas a lograr al leerlo
          </h2>
          <p className="text-xl text-gray-600" data-id="element-6">
            Después de leer Juega Desde Otro Nivel, vas a poder:
          </p>
        </div>
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} data-id="element-7">
          <img src="https://res.cloudinary.com/dyxo8wdrc/image/upload/f_auto,q_auto/v1766234477/Gemini_Generated_Image_mhqi1ymhqi1ymhqi_jgcbs8.png" alt="Beneficios de Juega Desde Otro Nivel" className="w-full h-auto rounded-2xl shadow-xl" data-id="element-8" />
        </motion.div>
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-9">
        {['Identificar dónde estás perdiendo energía', 'Detectar tu techo invisible', 'Limpiar tu agenda sin culpa', 'Tomar decisiones con un filtro claro', 'Diferenciar lo urgente de lo importante', 'Diseñar un sistema diario que sostenga tu avance'].map((benefit, i) => <div key={i} className="p-6 bg-gray-50 rounded-xl border border-gray-100 hover:border-amber-200 transition-colors duration-300" data-id="element-10">
            <Target className="w-8 h-8 text-amber-500 mb-4" data-id="element-11" />
            <p className="text-lg font-medium text-gray-900" data-id="element-12">{benefit}</p>
          </div>)}
      </div>

      <div className="mt-12 text-center" data-id="element-13">
        <p className="text-2xl font-bold text-[#1A1A1A]" data-id="element-14">
          Menos improvisación. <br className="md:hidden" data-id="element-15" />
          <span className="text-amber-600" data-id="element-16">Más dirección.</span>
        </p>
      </div>
    </ContentSection>;
}